import c from "./constant";

export const setFilter = (dataName, filter) => ({
  type: c.SET_FILTER,
  filter,
  dataName
});

export const setSortBy = (dataName, sortBy) => ({
  type: c.SET_SORT_BY,
  sortBy,
  dataName
});

export const setSortDirection = (dataName, direction) => ({
  type: c.SET_SORT_DIRECTION,
  direction,
  dataName
});

export const register = (dataName, { direction, sortBy, filter }) => ({
  type: c.REGISTER,
  dataName,
  sortDirection: direction,
  sortBy,
  filter
});

export const unregister = dataName => ({
  type: c.UNREGISTER
});

export const setCrumb = (dataName, crumb, columnIndex, rowIndex) => ({
  type: c.SET_CRUMB,
  dataName,
  crumb,
  rowIndex,
  columnIndex
});

// export const setCursor = (dataName, cursor) => ({
//   type: c.SET_CURSOR,
//   cursor
// });

// export const addCursor = (dataName, cursor) => ({
//   type: c.ADD_CURSOR,
//   cursor
// });

// export const clearCursors = (dataName) => ({
//   type: c.CLEAR_CURSORS
// });
